<template>
  <v-app>
    <v-overlay dark z-index="100" v-if="$store.state.globalLoading">
      <div class="text-center">
        <v-progress-circular
            indeterminate
            size="40"
            width="3"
            color="white"
        />
      </div>
      <div class="font-weight-medium caption mt-4">Выполняется...</div>
    </v-overlay>
    <router-view/>
    <v-snackbar
        v-model="$store.state.snack.status"
        bottom
    >
      {{ $store.state.snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
            :color="$store.state.snack.type === 'error' ? 'red' : 'success'"
            text
            v-bind="attrs"
            @click="$store.dispatch('hideSnack')"
        >
          OK
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
